module.exports = __webpack_public_path__ + "media/images/emoticons/bearing-be62e696e04e96902e31fa133ff224c8.gif";